var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 40,
    viewBox: "0 0 136 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17495_79689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.3423 4.28589H76.436V35.7145H59.3423V4.28589Z",
    fill: "#FF5F00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.371 20C60.371 13.6111 63.4497 7.94444 68.1818 4.27778C64.704 1.61111 60.314 0 55.5248 0C44.1792 0 35 8.94444 35 20C35 31.0556 44.1792 40 55.5248 40C60.314 40 64.704 38.3889 68.1818 35.7222C63.4497 32.1111 60.371 26.3889 60.371 20Z",
    fill: "#EB001B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.363 20C101.363 31.0556 92.1843 40 80.8386 40C76.0495 40 71.6595 38.3889 68.1816 35.7222C72.9708 32.0556 75.9925 26.3889 75.9925 20C75.9925 13.6111 72.9138 7.94444 68.1816 4.27778C71.6595 1.61111 76.0495 0 80.8386 0C92.1843 0 101.363 9 101.363 20Z",
    fill: "#F79E1B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17495_79689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 136,
    height: 40,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.791c4fd87728749c6748b2ca3fe1b1af.svg";
export { ForwardRef as ReactComponent };